export default "__VITE_ASSET__CX_g89sO__"